 
import styled, { css } from 'styled-components';
import { Col as BootstrapCol } from 'react-bootstrap';
import Button from 'v3/components/Button';

import theme from 'v3/theme';

export const STATUS_COLORS = {
  successBg: '#d8f7f0',
  successBorder: '#bfeee1',
  warningBg: '#fff3c4',
  warningBorder: '#f6e7a3',
  successMarker: '#11a995',
  warningMarker: '#f5b83a',
};

export const Marker = styled.div`
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: ${theme.colors.medium_gray};
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 4px;
  left: 0;

  ${({ $completed }) =>
    $completed &&
    css`
      border-color: ${STATUS_COLORS.successMarker};
      background-color: ${STATUS_COLORS.successMarker};
    `}

  ${({ $progress, $completed }) =>
    $progress &&
    !$completed &&
    css`
      border-color: ${STATUS_COLORS.warningMarker};
      background-color: ${STATUS_COLORS.warningMarker};
    `}

  ${({ $progress, $completed }) =>
    !$progress &&
    !$completed &&
    css`
      border-color: ${theme.colors.medium_gray};
      background-color: ${theme.colors.medium_gray};
    `}
`;

export const EditButton = styled(Button)`
  margin: 8px auto 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 4px 10px;
  font-size: 12px;
`;

Marker.Tray = styled.div`
  border-left: 2px dashed ${theme.colors.medium_gray};
  width: 0;
  position: absolute;
  left: 7px;
  top: 18px;
  bottom: 0;

  ${({ $completed }) =>
    $completed &&
    css`
      border-color: ${STATUS_COLORS.successMarker};
      background-color: ${theme.colors.white};
    `}

  ${({ $progress, $completed }) =>
    $progress &&
    !$completed &&
    css`
      border-color: ${STATUS_COLORS.warningMarker};
      background-color: ${theme.colors.white};
    `}

  ${({ $progress, $completed }) =>
    !$progress &&
    !$completed &&
    css`
      border-color: ${theme.colors.medium_gray};
      background-color: ${theme.colors.white};
    `}
`;

export const SectionDivider = styled.div`
  border-top: 1px solid #e6e6e6;
  margin: 0 0 16px 0;
`;

export const SectionTitle = styled.div`
  display: flex;
  align-items: center;
  padding-bottom: 8px;
  margin-bottom: 16px;
  border-bottom: 1px solid #e6e6e6;
`;

export const Schedules = styled(BootstrapCol)`
  padding: 12px 16px;
  border-radius: 5px;
  border: 1px solid ${theme.colors.secondary};
  margin-bottom: 35px;
  position: relative;
  display: flex;
  align-items: flex-start;
  height: 100%;

  ${({ $noBg }) =>
    $noBg &&
    css`
      background-color: transparent;
      border-color: transparent;
      padding: 0;
    `}

  & > .row {
    width: 100%;
  }

  ${({ $progress, $completed }) =>
    $completed &&
    $progress &&
    css`
      border-color: transparent;
      background-color: ${STATUS_COLORS.successBg};
    `}

  ${({ $progress, $completed }) =>
    $progress &&
    !$completed &&
    css`
      border-color: transparent;
      background-color: ${STATUS_COLORS.warningBg};
    `}

    ${({ $progress, $completed }) =>
    !$progress &&
    !$completed &&
    css`
      border-color: ${theme.colors.white};
      background-color: ${theme.colors.white};
    `}

  .schedule-col {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 20px;
  }

  .schedule-col + .schedule-col::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    border-left: 2px dotted ${theme.colors.medium_gray};
    opacity: 0.7;
  }

  .schedule-col.waiting-col::before,
  .schedule-col.waiting-col + .schedule-col::before {
    content: none;
  }
`;

export const RouteColumnsGrid = styled.div`
  display: grid;
  grid-template-columns: ${({ $hasStartSchedule }) =>
    $hasStartSchedule ? '3fr 2fr 1fr 2fr' : '2fr 2fr 1fr 2fr'};
  align-items: stretch;
  width: 100%;
  height: 100%;
`;

export const RouteGridCell = styled.div`
  height: 100%;
  padding: 0 0.75rem;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const RouteGridBodyCell = styled(RouteGridCell)`
  position: relative;
  align-self: stretch;

  ${({ $showDivider }) =>
    $showDivider &&
    css`
      &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        border-left: 1px dashed ${theme.colors.medium_gray};
      }
    `}
`;

// Global helpers for the combined origin/schedules row
export const GlobalRouteLine = styled.div`
  .route-line-header {
    padding: 12px;
  }

  .route-line-header > .row {
    width: 100%;
  }

  .route-line-wrapper {
    display: flex;
    align-items: stretch;
  }

  .route-line-wrapper > .row {
    width: 100%;
  }

  .route-schedules-col {
    position: relative;
    height: 100%;
    display: flex;
  }

  .route-schedules-box {
    width: 100%;
    height: 100%;
  }

  .route-schedules-col::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    border-left: 2px dotted ${theme.colors.medium_gray};
    opacity: 0.7;
  }
`;
